import update from "immutability-helper";

import {
  //Редактирование формы вопроса
  SET_QUESTION_HEADER,
  SET_QUESTION_ANSWER_TEXT,
  SET_QUESTION_ROLE,
  CLEAR_QUESTION_FORM,
  //Подвопросы
  SET_SUBQ_HEADER,
  SET_SUBQ_ANSWER_TEXT,
  ADD_NEW_SUBQUESTION,
  DELETE_SUBQUESTION,
  //Загрузка информации о вопросе
  EDITING_QUESTION_LOADING_START,
  EDITING_QUESTION_LOADED_SUCCESSFULLY, 
  EDITING_QUESTION_LOADING_FAILED,
  //Редактирование вопроса
  QUESTION_EDITING_START,
  QUESTION_EDITED_SUCCESSFULLY,
  QUESTION_EDITING_FAILED,
  //Создание вопроса
  QUESTION_CREATION_START,
  QUESTION_CREATED_SUCCESSFULLY,
  QUESTION_CREATION_FAILED,
} from "../actions/editQuestion";

//Получение количества вопросов
import {
  QUESTIONS_COUNT_LOADED_SUCCESSFULLY
} from "../actions/ui";

import { SIGN_OUT } from '../actions/auth';

const INITIAL_STATE = {
  ready: true,
  loading: false,
  question: {
    id: 0,
    header: '',
    answer: '',
    role: 'client',
    children: [],
  },
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    //Редактирование и создание вопроса
    case EDITING_QUESTION_LOADED_SUCCESSFULLY:
      return {
        ...state,
        ready: true,
        loading: false,
        question: action.payload.question,
      };
    case EDITING_QUESTION_LOADING_FAILED:
    case QUESTION_EDITING_FAILED:
    case QUESTION_CREATION_FAILED:
      return {
        ...state,
        ready: false,
        loading: false,
      };
    //Редактирование вопроса
    case EDITING_QUESTION_LOADING_START:
    case QUESTION_EDITING_START:
    case QUESTION_CREATION_START:
      return {
        ...state,
        ready: false, 
        loading: true,
      };
    case QUESTION_EDITED_SUCCESSFULLY:
    case QUESTION_CREATED_SUCCESSFULLY:
    case CLEAR_QUESTION_FORM:
      return INITIAL_STATE;
    //Редактирование формы вопроса
    case SET_QUESTION_HEADER:
      return update(state, {
        question: {
          header: {$set: action.payload.value},
        }
      });
    case SET_QUESTION_ANSWER_TEXT:
      return update(state, {
        question: {
          answer: {$set: action.payload.value},
        }
      });
    case SET_QUESTION_ROLE:
      return update(state, {
        question: {
          role: {$set: action.payload.value},
        }
      });
    //Подвопросы
    case SET_SUBQ_HEADER:
      return update(state, {
        question: {
          children: {
            [action.payload.subQIndex]: {
              header: {$set: action.payload.value},
            }
          },
        }
      });
    case SET_SUBQ_ANSWER_TEXT:
      return update(state, {
        question: {
          children: {
            [action.payload.subQIndex]: {
              answer: {$set: action.payload.value},
            }
          },
        }
      });
    case ADD_NEW_SUBQUESTION:
      const newSubQuestion = { header: '', answer: '', isAdded: true };
      return update(state, {
        question: {
          children: { $push: [newSubQuestion] },
        },
      });
    //Удаление подвопроса
    case DELETE_SUBQUESTION:
      return update(state, {
        question: {
          children: { $splice: [[action.payload.subQIndex, 1]] },
        },
      });
    //Получение количества вопросов для клиентов и консультантов
    case QUESTIONS_COUNT_LOADED_SUCCESSFULLY:
      //Если количество вопросов больше 5, установим вопросу роль "Для консультантов"
      if (action.payload.forClients >=5) {
        return update(state, {
          question: {
            role: {$set: 'consultant'},
          },
        });
      }
      return state;
    case SIGN_OUT:
      return INITIAL_STATE;
    default:
      return state;
  }
}
